import { setDevisCookie, getCookie, checkNumber } from './functions';
/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/
/*						DEVIS COOOKIE							*/
/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/

/**
 * On cache les message d'erreur et d'ajout au panier
 */
function hideMessages() {
    $('#qte-error').hide();
    $('#qte-stock').hide();
    $('#alert-panier').hide();
    $('#global-error').hide();
}

/**
 * ajout d'un produit dans le devis
 */
$('#submit-devis').on('click', function() {
    hideMessages();
    // recupere les valeurs à ajouté dans le cookie
    /** @type string */
    let devisValue = $('#qte-devis').val();
    /** @type string */
    let produitInfo = $('.contenuPage').data('info-produit');
    /** @type HTMLSpanElement */
    let error = $('#qte-error');

    // Si le champ Quantité est vide on stoppe le traitement
    if (devisValue === '') {
        $('#qte-devis').addClass('border-danger');
        error.css('display', 'block');
    } else if (devisValue !== '') {
        // Enlève l'affiche de l'erreur si présente
        error.css('display', 'none');

        // rassemble ces valeurs dans un même objet
        produitInfo = { ...produitInfo, value: devisValue };

        // recupere le cookie devis
        let cookieDevis = getCookie('devis');
        let listProduit = [];

        // si le cookie existe déjà, recuperer sa valeur et redefinir listProduit
        if (cookieDevis !== null) {
            listProduit = JSON.parse(cookieDevis);
            produitInfo = { ...produitInfo, id: listProduit.length + 1 };
        } else {
            produitInfo = { ...produitInfo, id: 1 };
        }

        listProduit.push(produitInfo);
        document.cookie = setDevisCookie(listProduit);

        // recupere le panier devis
        let panierDevis = $('#panier-devis');

        // si il n'a pas de valeur indiquant le nombre d'element dans le panier devis, l'initialisé à 1
        if (panierDevis.text().length === 0) {
            panierDevis.text(1);
        } else {
            // sinon incrémenter la valeur actuel de 1
            let panierValue = panierDevis.text();
            panierValue = parseInt(panierValue) + 1;
            panierDevis.text(panierValue);
        }

        // ajouté une class pour faire un effet de notification qui s'effacera dans 2sec
        $('#submit-devis').addClass('produit-ajoute');
        $('.outilsSite-devis').addClass('produit-ajoute');

        setTimeout(() => {
            if ($('#submit-devis').hasClass('produit-ajoute')) {
                $('#submit-devis').removeClass('produit-ajoute');
            }
            if ($('.outilsSite-devis').hasClass('produit-ajoute')) {
                $('.outilsSite-devis').removeClass('produit-ajoute');
            }
        }, 2000);

        // On vide le champs une fois la valeur traitée et en cookie
        $('#qte-devis').val('');
        if ($('#qte-devis').hasClass('border-danger')) {
            $('#qte-devis').removeClass('border-danger');
        }
    }
});

/**
 * Empeche de saisir autre chose dans le champ de devis des fiches produit
 * Source: https://stackoverflow.com/questions/17209180/jquery-keyup-function-check-if-number
 */
$('#qte-devis').on('keypress', checkNumber());

$('#select-quantity').on('change', function() {
    const cond = $(this).val();
    if (cond !== undefined) {
        $('#item-quantity').html(produit.stock[cond]);
        $('#item-tarif').html(produit.tarif[cond]);

        $('#qte').attr({ max: produit.stock[cond] });
        $('#qte').val('1');
    }
});

$('#qte').on('change', function() {
    if (Number.parseInt($(this).val()) > Number.parseInt($(this).attr('max'))) {
        $(this).val($(this).attr('max'));
        $('#qte-stock').hide();
        $(this).removeClass('is-invalid');
    }
});

$('#qte').on('input', function() {
    hideMessages();
    if ($(this).val() != '') {
        $('#qte-error').hide();
    }
    if (Number.parseInt($(this).val()) > Number.parseInt($(this).attr('max'))) {
        $(this).addClass('is-invalid');
        $('#qte-stock').show();
    } else {
        $(this).removeClass('is-invalid');
        $('#qte-stock').hide();
    }
});

$('#ajout-panier-btn').on('click', function() {
    const conditionnement = $('#select-quantity').val();
    const quantite = $('#qte').val();
    hideMessages();

    if (quantite == '') {
        $('#qte-error').show();
        return;
    }

    let formData = new FormData();

    formData.append('id', id);
    formData.append('identifier', identifier);
    formData.append('nom', nom);
    formData.append('categorie', categories);
    formData.append('condlabel', condlabel);

    formData.append('conditionnement', conditionnement);
    formData.append('quantite', quantite);

    fetch(`${$("#main").data("url-panier")}/ajout`, {
        body: formData,
        method: 'post'
    }).then((data) => {
        return data.json();
    }).then((data) => {
        if(!data.error) {
            $('#alert-panier').show();
            $("#panier-qte-compteur").html(Number.parseInt(data.quantite));

            if(data.quantite <= 0) {
                $('#panier-qte-compteur').hide();
                $('#panier-picto').attr('data-original-title', $('#panier-picto').attr('if-empty'))
            } else {
                $('#panier-qte-compteur').show();
                $('#panier-picto').attr('data-original-title', $('#panier-picto').attr('not-empty'))
            }

        } else {
            $('#alert-panier').hide();
            $('#global-error').html(data.message);
            $('#global-error').show();
        }
    });
});
